import { axios } from '@/utils/request'

/**
 * 客户列表
 * @param parameter
 * @returns {*}
 */
export function getCustomerList (parameter) {
  return axios({
    url: '/customer/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 编辑客户
 * @param parameter
 * @returns {*}
 */
export function editCustomer (parameter) {
  return axios({
    url: '/customer/edit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增客户
 * @param parameter
 * @returns {*}
 */
export function addCustomer (parameter) {
  return axios({
    url: '/customer/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除客户
 * @param parameter
 * @returns {*}
 */
export function deleteCustomer (parameter) {
  return axios({
    url: '/customer/delete',
    method: 'post',
    data: parameter
  })
}
